var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.ordered ? 'ol' : 'ul',_vm._b({tag:"component",staticClass:"atom-list"},'component',_vm.elementBindings,false),[_c('layout-flexbox',{attrs:{"direction":"column","align":"stretch","spacing":_vm.spacing}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }